import { IconProps, Icon } from "@chakra-ui/react";

const AdditionalPin = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 19 23" {...props}>
      <path
        d="M0 0H12.414L18 5.586V11H16V8H10V2H2V20H9V22H0V0ZM12 2.414V6H15.586L12 2.414ZM11 14.5C11 13.837 11.2634 13.2011 11.7322 12.7322C12.2011 12.2634 12.837 12 13.5 12C14.163 12 14.7989 12.2634 15.2678 12.7322C15.7366 13.2011 16 13.837 16 14.5V19H14V14.5C14 14.3674 13.9473 14.2402 13.8536 14.1464C13.7598 14.0527 13.6326 14 13.5 14C13.3674 14 13.2402 14.0527 13.1464 14.1464C13.0527 14.2402 13 14.3674 13 14.5V19C13 19.5304 13.2107 20.0391 13.5858 20.4142C13.9609 20.7893 14.4696 21 15 21C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19V15H19V19C19 20.0609 18.5786 21.0783 17.8284 21.8284C17.0783 22.5786 16.0609 23 15 23C13.9391 23 12.9217 22.5786 12.1716 21.8284C11.4214 21.0783 11 20.0609 11 19V14.5Z"
        fill="currentColor"
      />
    </Icon>
  );
};

export default AdditionalPin;
